import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Referral } from "../../../core/model/v2/appointment/referral";
import { ICDCode } from "../../../core/model/v2/global-data/icdcode";
import { Patient } from "../../../core/models/patient/patient";
import { PractitionerReferral } from "../../../core/model/v2/practitioner/practitionerReferral";
import { Specialty } from "../../../core/model/v2/specialty";
import { CommonService } from "../../../core/services/v2/common.service";
import { GlobalDataService } from "../../../core/services/v2/global-data.service";
import { PracticeService } from "../../../core/services/v2/practice.service";
import { PreviewDocumentComponent } from "../../../shared/components/preview-document/preview-document.component";
import { WindowLoaderService } from "../../../shared/components/window-loader/window-loader.service";
import { PhysicianOptionService } from "../../shared/physician-option/physician-option.service";
import { FormControl, FormGroup } from "@angular/forms";
import { debounceTime, switchMap } from "rxjs/operators";
import { UtilsService } from "../../../core/services/v2/utils.service";

@Component({
  selector: "app-physician-refer-patient",
  templateUrl: "./physician-refer-patient.component.html",
  styleUrls: ["./physician-refer-patient.component.scss"],
})
export class PhysicianReferPatientComponent implements OnInit {
  @Input() patientData: Patient;
  @Output() cancelEvent = new EventEmitter();

  specialty: Specialty[];
  referralData: Referral;
  stepNo: number = 0;
  nextValue: string = "Next Step";
  step1Validated: boolean = false;
  practId: number;
  zipCode: string = "";
  searchField: FormControl = new FormControl('');

  icdOptions: ICDCode[];

  selectedUrgency: string;

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;

  urgencyOptions: any[] = [
    {
      itemValue: "STATINSIDE24HOURS",
      itemDescription: "STAT - Inside 24 Hours",
    },
    {
      itemValue: "ASAP24TO48HOURS",
      itemDescription: "ASAP - 24 to 48 Hours",
    },
    {
      itemValue: "NEXTAVAILABLE",
      itemDescription: "Next Available..",
    },
  ];
  constructor(
    private practiceService: PracticeService,
    private physicianOptionService: PhysicianOptionService,
    private commonService: CommonService,
    private globalDataService: GlobalDataService,
    public dialog: MatDialog,
    private loaderService: WindowLoaderService,
    private utils: UtilsService
  ) { }

  ngOnInit() {
    this.referralData = new Referral();
    this.referralData.validICD = false;
    this.selectedUrgency = "STATINSIDE24HOURS";
    this.searchField.valueChanges.pipe(
      debounceTime(500),
      switchMap(changedValue => this.loaderService.blockWithLoader(this.practiceService.getPractitionersByName(changedValue, this.zipCode))),
    ).subscribe(productList => this.practs = productList.practitioners.slice(0, 100));

  }

  cancel() {
    //this.showHideSelected = true;
    this.stepNo = 0;
    this.nextValue = "Next Step";
    this.referralData = new Referral();
    //this.showSelected();
    this.cancelEvent.emit(this.patientData);
  }

  nextStep() {
    if (this.stepNo == 0) {
      this.step1Validated = true;
      if (this.referralData.icd10Code) {
        this.loaderService.show();
        this.globalDataService
          .validateICDCode(this.referralData.icd10Code)
          .subscribe(
            (res) => {
              if (res) {
                this.referralData.icdDescription = res.description;
                this.referralData.validICD = res.valid;
                if (res.valid && res.description) this.stepNo += 1;
                else return;
              }
            },
            (error) => {
              console.error(error);
              this.loaderService.hide();
            },
            () => {
              this.loaderService.hide();
            }
          );
      } else return;
    } else if (this.stepNo < 3) {
      this.step1Validated = false;
      this.stepNo += 1;
    }

    if (this.stepNo == 2) this.getPhysicians("Favorites");

    if (this.stepNo == 3 && this.nextValue == "Send") {
      var practNPIs: string[] = [];
      this.getSummaryPracts().forEach((pract) => {
        practNPIs.push(pract.practitionerNPI);
      });

      var referralSummary = {
        fromPractitionerId: this.physicianOptionService.getPhysician().id,
        patientId: this.patientData.id,
        toPractitionerNpis: practNPIs,
        symptoms: this.referralData.symptoms,
        icdcode: this.referralData.icd10Code,
        additionalInstructions: this.referralData.instructions,
        urgencyType: this.selectedUrgency,
      };

      this.loaderService.show();
      this.practiceService.addPractitionerReferral(referralSummary).subscribe(
        (res) => {
          this.loaderService.show();
          if (res["response"]["isSuccess"]) {
            res.practitionerReferralDetail.forEach(
              (pracitionerReferralResponse) => {
                this.getSummaryPracts().forEach((pract) => {
                  if (
                    pracitionerReferralResponse.toPractitionerNpis[0] ===
                    pract.practitionerNPI
                  ) {
                    if (pract.attachedDocuments) {
                      pract.attachedDocuments.forEach((attachment) => {
                        this.loaderService.show();
                        this.practiceService
                          .uploadPractitionerReferralAttachment(
                            pracitionerReferralResponse.id,
                            attachment
                          )
                          .subscribe(
                            (_) => {
                              this.loaderService.hide();
                            },
                            (error) => {
                              console.error(error);
                              this.loaderService.hide();
                            },
                            () => {
                              this.loaderService.hide();
                            }
                          );
                      });
                    }
                  }
                });
              }
            );
            this.utils.showMessageSnackBar('Patient referal has been sent successfully.');
          }
          else {
            if (res && res.response && res.response.message)
              this.utils.showMessageSnackBar(res.response.message, true);
          }
          this.cancel();
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
    }

    if (this.stepNo == 3) this.nextValue = "Send";
  }

  previousStep() {
    if (this.stepNo > 0) this.stepNo -= 1;

    if (this.stepNo < 3) this.nextValue = "Next Step";
  }

  attachFile(event, practitioner: PractitionerReferral) {
    if (!practitioner.attachedDocuments) {
      practitioner.attachedDocuments = new Array<any>();
    }
    practitioner.attachedDocuments.push(event.target.files[0]);
  }

  deleteFile(file: File, practitioner: PractitionerReferral) {
    const index = practitioner.attachedDocuments.indexOf(file);
    if (index >= 0) {
      practitioner.attachedDocuments.splice(index, 1);
    }
  }

  viewFile(file: File) {
    const dialogRef = this.dialog.open(PreviewDocumentComponent, {
      id: "view-dialog",
      width: "90%",
      height: "90%",
      hasBackdrop: true,
      disableClose: true,
      backdropClass: "preview-modal",
      data: { documentLocation: file, isFrame: true },
    });
  }

  removeAttachedFile(practitioner: PractitionerReferral, file: File) {
    const fileIndex = practitioner.attachedDocuments.indexOf(file);
    if (fileIndex !== -1) {
      practitioner.attachedDocuments.splice(fileIndex, 1);
    }
  }

  action: string = "Favorites";
  displayedPractColumns: string[] = ["select", "physician", "specialty"];
  displayedSummaryColumns: string[] = [
    "select",
    "physician",
    "specialty",
    "attachment",
  ];
  practs: PractitionerReferral[] = [];

  getPhysicians(action: string, input?: string) {
    if (action == "OnCall") return;

    this.action = action;
    this.practs = [];

    if (this.action == "Favorites") {
      this.loaderService.show();
      this.practiceService
        .getPractitionerFavorites(
          this.physicianOptionService.getPhysician().id,
          "1"
        )
        .subscribe(
          (res) => {
            if (res) {
              this.practs = res.practitioners;
            }
            this.loaderService.hide();
          },
          (error) => {
            console.error(error);
            this.loaderService.hide();
          },
          () => {
            this.loaderService.hide();
          }
        );
    }
    else if (this.action == "Search") {
      if (input) {
        this.loaderService.show();
        this.practiceService
          .getPractitionersByName(input, this.zipCode)
          .subscribe(
            (res) => {
              if (res) {
                this.practs = res.practitioners.slice(0, 100);
              }
              this.loaderService.hide();
            },
            (error) => {
              console.error(error);
              this.loaderService.hide();
            },
            () => {
              this.loaderService.hide();
            }
          );
      }
    } else if (this.action == "Specialty") {
      if (!this.specialty) {
        this.loaderService.show();
        this.commonService.getSpecialty().subscribe(
          (response) => {
            this.specialty = response.specialties;
            this.loaderService.hide();
          },
          (error) => {
            console.error(error);
            this.loaderService.hide();
          },
          () => {
            this.loaderService.hide();
          }
        );
      }

      if (input) {
        this.loaderService.show();
        this.practiceService
          .getPractitionersBySpecialtyName(input, this.zipCode)
          .subscribe(
            (res) => {
              if (res) {
                this.practs = res.practitioners.slice(0, 100);
              }
              this.loaderService.hide();
            },
            (error) => {
              console.error(error);
              this.loaderService.hide();
            },
            () => {
              this.loaderService.hide();
            }
          );
      }
    }
  }

  specialtyEvent(event): void {
    if (event.value) {
      this.getPhysicians("Specialty", event.value);
    }
  }

  getSelectedUrgency(): string {
    var urgency = this.urgencyOptions[2];
    this.urgencyOptions.forEach((element) => {
      if (element.itemValue == this.selectedUrgency) urgency = element;
    });
    return urgency.itemDescription;
  }

  phySelectionChange(event) {
    this.practs.forEach((pract) => {
      if (pract.practitionerNPI == event.practitionerNPI) {
        if (pract.checked) pract.checked = !pract.checked;
        else pract["checked"] = true;
      }
    });
  }

  getSummaryPracts(): PractitionerReferral[] {
    var summaryPracts: PractitionerReferral[] = [];
    summaryPracts = this.practs.filter(
      (pract) => pract.checked && pract.checked == true
    );
    return summaryPracts;
  }

  getNavCode(step: number): string {
    var navCode: string = "nav-status";

    if (step == 1) {
      if (this.stepNo == 1) navCode += " progress";
      else navCode += " completed";
    } else if (step == 2) {
      if (2 == this.stepNo) navCode += " progress";
      else if (this.stepNo < 2) navCode += " pending";
      else if (this.stepNo > 2) navCode += " completed";
    } else if (step == 3) {
      if (3 == this.stepNo) navCode += " progress";
      else if (this.stepNo < 3) navCode += " pending";
      else if (this.stepNo > 3) navCode += " completed";
    }

    return navCode;
  }

  getStatus(stepNo: number) {
    return this.stepNo >= stepNo;
  }

  searchICDCodes(filter: string): void {
    if (filter.length >= 3) {
      this.globalDataService.getICDCodes(filter).subscribe(
        (icd) => {
          this.icdOptions = icd;
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }
  selectSymptom(option: ICDCode): void {
    this.referralData.symptoms = option.description;
    this.referralData.icd10Code = option.icdCode;
    this.referralData.validICD = true;
  }


  searchPatient(filter: string) {
    if (filter.length >= 3) {
      this.loaderService.show();
      this.practiceService
        .getPractitionersByName(filter, this.zipCode)
        .subscribe(
          (res) => {
            if (res) {
              this.practs = res.practitioners.slice(0, 100);
            }
            this.loaderService.hide();
          },
          (error) => {
            console.error(error);
            this.loaderService.hide();
          },
          () => {
            this.loaderService.hide();
          }
        );
    }
  }
}
